import {
  CButton,
  CButtonGroup,
  CCol,
  CFormGroup,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem, updateItem, ItemRequestStatus } from "../../api/generics";
import Errors, { getFieldErrors } from "../../models/errors";
import { SUCCESS } from "../../utils/constants/tags";
import { FieldErrors } from "../form/FieldErrors";
import { errorAlert } from "../utils/messages";
import { emptyValueOnUndefined } from "../../utils/fields";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import Tag, { newTag } from "../../models/tag";

interface TagFormProps {
  initialTag?: Tag;
  initialErrors?: Errors;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const TagForm: React.FC<TagFormProps> = ({
  initialTag,
  initialErrors,
  onCancel,
  onSuccess,
}) => {
  const company = useSelector((state: RootState) => state.company.data.company);
  const [editingTag, setEditingTag] = useState<Tag>(
    initialTag ? initialTag : newTag()
  );

  const [errors, setErrors] = useState<Errors>(
    initialErrors ? initialErrors : {}
  );
  const [submitting, setSubmitting] = useState(false);

  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditingTag({
      ...editingTag,
      name: e.target.value,
    });
  };

  const onSave = async () => {
    setSubmitting(true);
    let toSendTag = {
      ...editingTag,
      companyId: company.id,
    };
    let requestPromise: Promise<ItemRequestStatus<Tag>>;
    if (editingTag.id === undefined) {
      requestPromise = createItem<Tag>("/tags/create/", toSendTag);
    } else {
      requestPromise = updateItem<Tag>(`/tags/${toSendTag.id}/`, toSendTag);
    }

    const tagstatus = await requestPromise;

    if (tagstatus.status !== SUCCESS) {
      if (tagstatus.errors !== undefined) {
        setErrors(tagstatus.errors);
      }

      let message = "Ha ocurrido un error!!";
      if (tagstatus.detail !== undefined) {
        message = tagstatus.detail;
      }
      errorAlert(message);
    } else {
      setErrors({});
      clearForm();
      onSuccess();
    }
    setSubmitting(false);
  };

  const onClose = () => {
    clearForm();
    onCancel();
  };

  const clearForm = () => {
    setEditingTag(newTag());
  };

  useEffect(() => {
    setEditingTag(initialTag ? initialTag : newTag());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialTag]);

  useEffect(() => {
    setErrors(initialErrors ? initialErrors : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialErrors]);

  return (
    <>
      <fieldset disabled={submitting}>
        <CFormGroup>
          <CRow>
            <CCol md={2}>
              <CLabel>Nombre:</CLabel>
            </CCol>
            <CCol>
              <CInput
                type="text"
                value={emptyValueOnUndefined(editingTag.name)}
                onChange={onNameChange}
                placeholder="Nombre"
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("name", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
        <CFormGroup className="float-right">
          <CButtonGroup>
            <CButton type="button" color="secondary" onClick={onClose}>
              Atras
            </CButton>
            <CButton type="submit" color="primary" onClick={onSave}>
              {submitting ? (
                <Spinner
                  animation="grow"
                  style={{
                    height: "17px",
                    width: "17px",
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginRight: "10px",
                  }}
                />
              ) : (
                <></>
              )}
              {submitting ? "Guardando..." : "Guardar"}
            </CButton>
          </CButtonGroup>
        </CFormGroup>
      </fieldset>
    </>
  );
};

export default TagForm;
